// super-simple flash memory implementation

const LOCAL_STORAGE_KEY = 'flash'

const r = {} // read
const w = {} // write

function load () {
  const s = localStorage.getItem(LOCAL_STORAGE_KEY)
  if (s) {
    const o = JSON.parse(s)
    if (typeof o === 'object') {
      Object.assign(r, o)
    }
  }
}

function save () {
  localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(w))
}

export default {
  install (app, options) {
    load()
    save()

    app.config.globalProperties.$flash = {
      set (key, value) {
        w[key] = value
        save()
      },
      get (key) {
        return r[key]
      },
      del (key) {
        delete w[key]
        save()
      },
    }
  },
}
